(function($){
  $(document).ready(function() {

    $('#resa_roulotte').click(function(e){
        e.preventDefault();
        $.ajax({
          url: '/inc/xhr/actions.php?action=form_roulottes',
          success: function(data) {
            $.popin.alert({title: "Reservation Roulottes", message: data, button: "fermer"});
            }
          });
    });
    $('#resa_ane').click(function(e){
        e.preventDefault();
        $.ajax({
          url: '/inc/xhr/actions.php?action=form_anes',
          success: function(data) {
            $.popin.alert({title: "Reservation Anes", message: data, button: "fermer"});
            }
          });
    });
    $('#resa_journee').click(function(e){
        e.preventDefault();
        $.ajax({
          url: '/inc/xhr/actions.php?action=form_journee',
          success: function(data) {
            $.popin.alert({title: "Demmande de devis > Journée", message: data, button: "fermer"});
            }
          });
    });
    $('#resa_sejour').click(function(e){
        e.preventDefault();
        $.ajax({
          url: '/inc/xhr/actions.php?action=form_sejour',
          success: function(data) {
            $.popin.alert({title: "Demmande de devis > Séjour", message: data, button: "fermer"});
            }
          });
    });

  })
})(jQuery);